<div class="component-container">
    <div class="well" style="height: 100%;">
        <div class="row" style="height: 100%; overflow: hidden;">
            <div class="panel panel-success" style="max-height: 100%; display: flex; flex-direction: column; justify-content: flex-start;">
                <div class="panel-heading" style="flex-grow: 0;">
                    <h5 style="display: inline-block">Parts Manual URL Management</h5>
                    <div class="btn-toolbar pull-right">
                        <div class="btn-group btn-group-md">

                            <button type="button" class="btn" title="Filter Equipment" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
                                <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="panel-body" style="padding-bottom: 30px; flex-grow: 1; overflow: hidden; display: flex; flex-direction: column; justify-content: flex-start;">
                    <div class="list-group" style="flex-grow: 0;">
                        <div class="list-group-item">
                            <div class="list-group-item-heading">
                                <div class="row">
                                    <div class="col-lg-2">
                                        <b>Serial</b>
                                    </div>
                                    <div class="col-lg-4">
                                        <b>PartsManual URL</b>
                                    </div>
                                    <div class="col-lg-4">
                                        <b>EDManual URL</b>
                                    </div>
                                    <div class="col-lg-2">
                                        <b>Edit</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="list-group" style="flex-grow: 1; overflow: hidden; overflow-y: auto;">
                        <div>
                            <div class="list-group-item list-group-item-info" *ngFor="let equipment of equipments">
                                <div class="row">
                                    <div class="col-lg-2">
                                        {{equipment?.Serial}}
                                    </div>
                                    <div class="col-lg-4">
                                        <input id="partsManualURL" name="partsManualURL" type="text" class="form-control xor-form-control" placeholder="partsManualURL" [(ngModel)]="equipment.PartsManualURL" disabled="disabled" />
                                    </div>
                                    <div class="col-lg-4">
                                        <input id="edManualURL" name="edManualURL" type="text" class="form-control xor-form-control" placeholder="edManualURL" [(ngModel)]="equipment.EDManualURL" disabled="disabled" />
                                    </div>
                                    <div class="col-lg-2">
                                        <button type="button" class="btn btn-info" title="Change URL" (click)="showModal(equipment?.Serial, equipment?.PartsManualURL, equipment?.EDManualURL)">
                                            <span class="fa fa-edit fa-lg"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div bsModal #partsmanualFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <form (ngSubmit)="applyFilter()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Equipment</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Serial Number</label>
                                </div>
                                <input name="serialFilter" id="serialFilter" type="text" class="form-control" placeholder="Serial Number" [(ngModel)]="serial" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Model</label>
                                </div>
                                <select name="selectedModelsFilter" id="selectedModelsFilter" class="form-control" size="10" multiple="multiple" (change)="getPoweredByForModel()">
                                    <option [id]="model.Id" *ngFor="let model of models" [value]="model.Id">{{ model.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Powered By</label>
                                </div>
                                <select name="selectedPowereBysFilter" id="selectedPowereBysFilter" class="form-control" size="10" (change)="getCompanyForModelAndPoweredBy()">
                                    <option [id]="poweredBy.Id" *ngFor="let poweredBy of poweredBys" [value]="poweredBy.Id">{{ poweredBy.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Company</label>
                                </div>
                                <select name="selectedCompaniesFilter" id="selectedCompaniesFilter" class="form-control" size="5" (change)="getMinesitesForModelAndPoweredByAndCompany()">
                                    <option [id]="company.Id" *ngFor="let company of companies" [value]="company.Id">{{ company.Name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Minesite</label>
                                </div>
                                <select name="selectedMinesitesFilter" id="selectedMinesitesFilter" class="form-control" size="5" (change)="minesiteSelected()">
                                    <option [id]="minesite.Id" *ngFor="let minesite of minesites" [value]="minesite.Id">{{ minesite.Name }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-close" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default" (click)="applyFilter()">Apply Filter</button>
                </div>
            </div>
        </form>
    </div>
</div>


<div bsModal #URLChange="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <form (ngSubmit)="submitURLChange()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="closeModal()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Update PartsManual and EDManual URLs</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group-addon">
                                <label>Serial Number : </label><label id="serialModal"></label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">

                        <div class="col-md-2">

                            <label>PartsManual URL</label>
                        </div>
                        <div class="col-md-8">
                            <input (change)="populateEDURL();" (keypress)="populateEDURL();" onpaste="populateEDURL();" (input)="populateEDURL();" id="partsManualURLModal" name="partsManualURLModal" type="text" class="form-control xor-form-control" placeholder="Enter the PartsManual URL" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">

                            <label>EDManual URL</label>
                        </div>
                        <div class="col-md-8">
                            <input id="edManualURLModal" name="edManualURLModal" type="text" class="form-control xor-form-control" placeholder="Enter the ED Manual URL" />

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-close" (click)="closeModal()">Cancel</button>
                    <button type="submit" class="btn btn-default">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
